import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';

let defaultForm = {
  name: '',
  ownership: 'ClientOwned',
  type: 'ManualShipmentImport',
  brandId: '',
  importSheetMappings: []
};

let defaultFilters = {
  search: '',
  brandId: '',
  type: null,
  ownership: null
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions,
  }
};